module.exports = __webpack_public_path__ + "img/Mb_Information.d5ab5b54.jpg";